module.exports = __webpack_public_path__ + "img/VIP-10.faa6cf9f.png";